// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.SatelliteWebLandlordWarningsHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { SatelliteWebLandlordUserWarningsResponseDto } from '../..';

export const SatelliteWebLandlordWarningsHandler_getUserWarnings_Path = '/api/web/landlord/v1/getUserWarnings';

/**
 * Get user warnings for personal contact details and external links
 */
export const SatelliteWebLandlordWarningsHandler_getUserWarnings = (client = getClient()) => {
  return httpFrontEndRequest<never, never, SatelliteWebLandlordUserWarningsResponseDto>(
    {
      endpoint: SatelliteWebLandlordWarningsHandler_getUserWarnings_Path,
      method: 'GET',
      contextPath: '/satellite',
    },
    client,
  );
};
